<div class="cartPreview__product" *ngIf="orderLine">
  <a [routerLink]="orderLine.product.path" (click)="closePreviewBox()">
    <vc-images
      *ngIf="orderLine.product.pictures"
      class="cartPreview__product__picture"
      url="/produit/{{ orderLine.product.pictures[0].path }}"
      width="56"
      height="56"
      alt=""
    ></vc-images>
  </a>

  <div class="cartPreview__product__description">
    <div class="cartPreview__product__line">
      <div class="cartPreview__product__line__text">
        <div class="cartPreview__product__brand">{{ orderLine.product.brand.name | lowercase }}</div>
        <div class="cartPreview__product__name">{{ orderLine.product.name }}</div>
        <p *ngIf="orderLine.product?.size?.size">
          {{ orderLine.product.size.size }}
          <span *ngIf="orderLine.product.size.localizedStandard">{{ orderLine.product.size.localizedStandard }}</span>
        </p>
      </div>
      <div class="cartPreview__product__line__amount">{{ orderLine.product.price.formatted }}</div>
    </div>
  </div>

  <button class="cartPreview__product__remove" (click)="remove(orderLine)">
    <vc-sprite-icons name="cross-x-thick" class="svg"></vc-sprite-icons>
  </button>
</div>
